import { gql } from '@apollo/client';

export const selectOfferAdditionalMutation = gql`mutation SelectOffer($id: String!) {
    selectOffer(id: $id)
  }
`